import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@td/shared_utils';
import moment from 'moment';
import { TdWindow } from '@td/utils';
import '../styles.scss';

import InformationTable from './information-table';
import { prescriberInfo } from '../utils/prescriberInfo';

class SurescriptsInformation extends Component {
  componentDidMount() {
    const { providerId, prescriberId } = this.props;

    if (prescriberId) {
      this.props.fetchPrescriber({ providerId, prescriberId });
    }
  }

  register = () => {
    const { providerId } = this.props;

    this.props.createPrescriber({ providerId });
  };

  update = (prescriberId) => {
    const { providerId } = this.props;

    this.props.updatePrescriber({ providerId, prescriberId });
  };

  refresh = (prescriberId) => {
    const { providerId } = this.props;

    this.props.refreshPrescriber({ providerId, prescriberId });
  }

  deactivate = (prescriberId) => {
    const { providerId } = this.props;

    this.props.deactivatePrescriber({ providerId, prescriberId });
  }

  openDetails = (prescriberId) => {
    const queryParams = {
      target_host: window.ERX_REGISTRATION_HOST,
      target_path: `providers/${prescriberId}`
    };

    TdWindow.redirect(`/remote_sso?${new window.URLSearchParams(queryParams).toString()}`);
  }

  reactivate = (prescriberId) => {
    const { providerId } = this.props;

    this.props.reactivatePrescriber({ providerId, prescriberId });
  }

  prescriberId = () => {
    const { prescriberId, prescriberInfo } = this.props;
    return prescriberId || prescriberInfo.id;
  }

  render() {
    const { fetched, loading, prescriberInfo, errors, registrationAvailable, providerRegistrationApplicationAvailable } = this.props;
    const prescriberId = this.prescriberId();

    const isActive = () => {
      if (prescriberInfo && prescriberInfo.service) {
        return moment(prescriberInfo.service.activeEndTime) > moment.now();
      }
    }

    const canReactivate = () => {
      if (prescriberInfo && prescriberInfo.service) {
        return moment.now() >= moment(prescriberInfo.service.activeEndTime).subtract(1, 'year');
      }
    }

    const extendOrReactivate = isActive() ? "extend" : "reactivate";

    return (
      <div>
        { !prescriberId && !loading && !errors.length && (
          <div>
            <p>
              <I18n scope='provider.surescripts_registration' text="no_surescripts" />
            </p>
            { registrationAvailable && (
              <button className="create" onClick={this.register}>
                <I18n scope="provider.surescripts_registration" text="register" />
              </button>
            )}
          </div>
        )}
        { loading && (
          <I18n scope="provider.surescripts_registration" text="loading" />
        )}
        { !!errors.length && (
          <div className="errors">
            <p>
              <I18n scope="provider.surescripts_registration" text="error" />
            </p>
            <p>{errors.join(', ')}</p>
          </div>
        )}
        { fetched && (
          <div>
            <InformationTable prescriberInfo={prescriberInfo} />

            <button className="refresh" onClick={() => this.refresh(prescriberId)} disabled={loading}>
              <I18n scope="provider.surescripts_registration" text="refresh" />
            </button>
            <button className="update" onClick={() => this.update(prescriberId)} disabled={loading}>
              <I18n scope="provider.surescripts_registration" text="update" />
            </button>
            {isActive() &&
              <button className="deactivate" onClick={() => this.deactivate(prescriberId)} disabled={loading}>
                <I18n scope="provider.surescripts_registration" text="deactivate" />
              </button>
            }
            {canReactivate() &&
              <button className={extendOrReactivate} onClick={() => this.reactivate(prescriberId)} disabled={loading}>
                <I18n scope="provider.surescripts_registration" text={extendOrReactivate} />
              </button>
            }
            {providerRegistrationApplicationAvailable && (
              <button className="details" onClick={() => this.openDetails(prescriberId)} disabled={loading}>
                <I18n scope="provider.surescripts_registration" text="details" />
              </button>
            )}
          </div>
        )}
      </div>
    );
  }
}

SurescriptsInformation.defaultProps = {
  fetched: false,
  loading: false,
  prescriberInfo: {},
  errors: []
};

SurescriptsInformation.propTypes = {
  providerId: PropTypes.number.isRequired,
  prescriberId: PropTypes.number,
  registrationAvailable: PropTypes.bool.isRequired,
  providerRegistrationApplicationAvailable: PropTypes.bool.isRequired,
  fetchPrescriber: PropTypes.func.isRequired,
  refreshPrescriber: PropTypes.func.isRequired,
  updatePrescriber: PropTypes.func.isRequired,
  deactivatePrescriber: PropTypes.func.isRequired,
  reactivatePrescriber: PropTypes.func.isRequired,
  createPrescriber: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetched: PropTypes.bool.isRequired,
  prescriberInfo: prescriberInfo,
  errors: PropTypes.array
};

export default SurescriptsInformation;
